import { PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLatest } from 'redux-saga/effects';
import { SpaceTabId } from 'api/models';
import { SpaceTabAPI } from 'api/space';
import { CreateSpaceFromTemplatepayload, SpaceTab } from 'api/space/space-tab';
import { addSpaceTabsToSpace, Space } from 'data/spaces';
import { getSpaceByIdSelector } from 'data/spaces/selectors';
import { logger } from 'services';
import { getSpaceTabDetailUrl } from 'utils/urls';
import { CreateSpaceTabPayload, createSpaceTabSagaAction } from '../actions';
import {
  createFailure,
  createStart,
  createSuccess,
  embedStart,
} from '../index';

function* createSpaceTabSaga(action: PayloadAction<CreateSpaceTabPayload>) {
  const { payload } = action;

  try {
    const { spaceTabId, handleSuccess, ...rest } = payload;
    const {
      space: { spaceId },
    } = rest;

    if (rest.spaceTabType) {
      yield put(createStart());
    } else {
      yield put(embedStart());
    }

    // TODO: remove 'as' and check if this saga is ever needed
    const response = (yield SpaceTabAPI.createSpaceTab(
      rest as CreateSpaceFromTemplatepayload,
    )) as SpaceTab;

    yield put(
      addSpaceTabsToSpace({
        spaceId,
        spaceTabs: [response.spaceTabId].map(String),
      }),
    );
    yield put(createSuccess(response));

    const space = (yield select(
      getSpaceByIdSelector(response.space.spaceId),
    )) as Space;

    const redirectPath = getSpaceTabDetailUrl(
      SpaceTabId<number>(space.project, spaceId, response.spaceTabId),
    );

    if (handleSuccess) {
      handleSuccess(redirectPath, spaceId);
    }
  } catch (error) {
    logger.error('getSpaceTabDetailUrl failed', { error });
    yield put(createFailure());
  }
}

export function* watchCreateSpaceTabSaga(): Generator {
  yield takeLatest(createSpaceTabSagaAction.type, createSpaceTabSaga);
}
